import { useState } from "react";
import emitPick from "../../../connector/emits/pick";
import "./Pick.scoped.scss";

const Pick = () => {
  const [selectedPick, setSelectedPick] = useState('');

  const submitPick = () => {
    if (selectedPick === '') {
      window.alert('픽을 선택해주세요.');
      return;
    }
    emitPick(selectedPick);
  };

  const resetPick = () => {
    setSelectedPick('');
  };

  return (
    <div className="pick">
      <div className="pick__left">
        <button
          style={{
            color: selectedPick === 'blue' ? 'blue' : '',
          }}
          onClick={() => setSelectedPick('blue')}
        >
          파랑거북이
        </button>
        <button
          style={{
            color: selectedPick === 'red' ? 'red' : '',
          }}
          onClick={() => setSelectedPick('red')}
        >
          빨강거북이
        </button>
        <button
          style={{
            color: selectedPick === 'green' ? 'green' : '',
          }}
          onClick={() => setSelectedPick('green')}
        >
          녹색거북이
        </button>
      </div>
      <div className="pick__right">
        <button
          onClick={submitPick}
        >
          픽하기
        </button>
        <button
          onClick={resetPick}
        >
          리셋
        </button>
      </div>
    </div>
  );
};

export default Pick;